import { render, staticRenderFns } from "./CourseOffered.vue?vue&type=template&id=89d7005a&scoped=true&"
import script from "./CourseOffered.vue?vue&type=script&lang=js&"
export * from "./CourseOffered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d7005a",
  null
  
)

export default component.exports